import { render } from "./MegaPageFrame.vue?vue&type=template&id=30bedf68&scoped=true"
import script from "./MegaPageFrame.vue?vue&type=script&lang=js"
export * from "./MegaPageFrame.vue?vue&type=script&lang=js"

import "./MegaPageFrame.vue?vue&type=style&index=0&id=30bedf68&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bedf68"]])

export default __exports__